import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const GameMatchLinks = ({ reviewHref, chessComUrl }: { reviewHref: string; chessComUrl?: string | null }) => (
  <>
    <Button component={RouterLink} to={reviewHref} size="small" variant="outlined">
      Review
    </Button>
    {chessComUrl && /^https:\/\/(?:www\.)?chess\.com\/game\/(?:live|daily)\/\d+(?:[/?#]|$)/i.test(chessComUrl) && (
      <Button
        component="a"
        href={chessComUrl}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        variant="outlined"
      >
        Chess.com
      </Button>
    )}
  </>
);
